<div class="basic-form no-gutters" *transloco="let t">
  <form class="col" [formGroup]="workplaceForm" (ngSubmit)="onSubmit()">
    <div class="row no-gutters">
      <div class="col-md col-12">
        <div class="row no-gutters">
          <div class="form-group col-12">
            <app-text-input
              [childForm]="workplaceForm"
              formControlName="workplaceName"
              [label]="t('settings/workplaceName')"
            ></app-text-input>
          </div>
          <div class="form-group col-12">
            <app-text-input [childForm]="workplaceForm" formControlName="izo" [label]="t('settings/izo') + '*'"></app-text-input>
          </div>
          <div class="form-group col-12">
            <app-text-input
              [childForm]="workplaceForm"
              formControlName="workplaceStreetAddress"
              [label]="t('settings/workplaceStreetAddress')"
            ></app-text-input>
          </div>
          <div class="form-group col-12">
            <app-text-input
              [childForm]="workplaceForm"
              formControlName="workplaceDistrict"
              [label]="t('settings/workplaceDistrict')"
            ></app-text-input>
          </div>
        </div>
      </div>
      <div class="col-md col-12 mt-md-0 mt-4">
        <div class="row no-gutters">
          <div class="form-group col-12">
            <app-text-input
              [childForm]="workplaceForm"
              formControlName="workplaceSchoolPartNumber"
              [label]="t('settings/workplaceSchoolPartNumber') + '*'"
            ></app-text-input>
          </div>
          <div class="form-group col-12">
            <app-text-input
              [childForm]="workplaceForm"
              formControlName="workplaceCity"
              [label]="t('settings/workplaceCity')"
            ></app-text-input>
          </div>
          <div class="form-group col-12">
            <app-text-input
              [childForm]="workplaceForm"
              formControlName="workplacePostcode"
              [label]="t('settings/workplacePostcode')"
            ></app-text-input>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="row no-gutters">
      <div class="d-flex justify-content-end col">
        <button class="btn btn-lg btn-primary" [disabled]="workplaceForm.invalid">
          {{ t('shared/save') }}
        </button>
      </div>
    </div>
  </form>
</div>
